import gql from "graphql-tag";

export const getCommune = gql`
  query getCommune {
    commune {
      id
      name
      region {
        full_name
        __typename @skip(if: true)
      }
      __typename @skip(if: true)
    }
  }
`;
